import {
    STRING_ACCESS_TOKEN_COMPRARTODO,
    STRING_SIDEBAR_EXPANDED_COMPRARTODO,
    STRING_LANGUAGE_COMPRARTODO,
    STRING_ID_ROL_COMPRARTODO,
    STRING_ID_TIPO_USUARIO_COMPRARTODO
} from "./const/string-const";

export const sharedNextPage = (page, params, history) => {
    try {
        // const history = useHistory();
        // history.push(`${page}`);
        // console.log('params');
        // console.log(params);
        if (params !== undefined && params !== null) {
            if (params.acciones !== undefined) {
                delete params.acciones;
            }
            // console.log('params sin acciones');
            // console.log(params);
            history.push({
                pathname: `${page}`,
                state: params
            });
        } else {
            history.push(`${page}`);
        }
    } catch (err) {
        console.log('nextPage err');
        console.log(err);
    }
};

export const sharedOpenNewTab = (page, params) => {
    try {
        // Open the new page in a new tab
        const newWindow = window.open(page, '_blank');

        // Wait until the new page is fully loaded, then send the data
        newWindow.onload = () => {
            console.log('onload');
            newWindow.postMessage(params, window.location.origin);
        };
    } catch (err) {
        console.log('sharedOpenNewTab error:', err);
    }
};

export const sharedMensajeConfirmacion = (message, data) => {
    try {
        return message + ': ' + data;
    } catch (err) {
        return message;
    }
};

/** API errors may arrive as string, Error, nested object, or empty {}. */
export const sharedApiErrorMessage = (message, fallback = "Process failed") => {
    try {
        if (typeof message === "string" && message.trim().length > 0) {
            return message;
        }
        if (message instanceof Error && message.message) {
            return message.message;
        }
        if (message && typeof message === "object") {
            if (typeof message.message === "string" && message.message.trim().length > 0) {
                return message.message;
            }
            const textParts = Object.values(message)
                .filter((value) => typeof value === "string" && value.trim().length > 0);
            if (textParts.length > 0) {
                return textParts.join("\n");
            }
        }
        return fallback;
    } catch (err) {
        return fallback;
    }
};

export const SHARED_MISSING_BEARER_TOKEN_MESSAGE = "missing bearer token";

export const sharedRedirectToLandingIfMissingBearerToken = (err) => {
    try {
        if (err?.message === SHARED_MISSING_BEARER_TOKEN_MESSAGE) {
            sharedClearData();
            window.location.assign("/landing");
            return true;
        }
        return false;
    } catch (redirectErr) {
        console.log("sharedRedirectToLandingIfMissingBearerToken error:", redirectErr);
        return false;
    }
};

export const sharedClearData = () => {
    try {
        localStorage.clear(STRING_ACCESS_TOKEN_COMPRARTODO);
        localStorage.clear(STRING_SIDEBAR_EXPANDED_COMPRARTODO);
        localStorage.clear(STRING_LANGUAGE_COMPRARTODO);
        localStorage.clear(STRING_ID_ROL_COMPRARTODO);
        localStorage.clear(STRING_ID_TIPO_USUARIO_COMPRARTODO);
    } catch (err) {
        console.log('sharedClearData error:', err);
    }
};

export const sharedInsertInfo = (data) => {
    try {
        // localStorage.setItem(STRING_SIDEBAR_EXPANDED_COMPRARTODO, true);
        if (data.token !== undefined) {
            localStorage.setItem(STRING_ACCESS_TOKEN_COMPRARTODO, data.token);
        }
        if (data.idRol !== undefined) {
            localStorage.setItem(STRING_ID_ROL_COMPRARTODO, data.idRol);
        }
        if (data.idTipoUsuario !== undefined) {
            localStorage.setItem(STRING_ID_TIPO_USUARIO_COMPRARTODO, data.idTipoUsuario);
        }
    } catch (err) {
        console.log('sharedInsertInfo error:', err);
    }
};

/**
 * Compress raster images via canvas — keeps visual quality, caps dimensions.
 * Returns a data URL ready for subirFile.
 */
export const sharedCompressImage = (file, options = {}) => {
    const maxWidth = options.maxWidth ?? 1920;
    const maxHeight = options.maxHeight ?? 1920;
    const quality = options.quality ?? 0.92;

    return new Promise((resolve, reject) => {
        const objectUrl = URL.createObjectURL(file);
        const image = new Image();

        image.onload = () => {
            URL.revokeObjectURL(objectUrl);

            let { width, height } = image;
            const scale = Math.min(1, maxWidth / width, maxHeight / height);
            width = Math.max(1, Math.round(width * scale));
            height = Math.max(1, Math.round(height * scale));

            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;

            const context = canvas.getContext("2d");
            if (!context) {
                reject(new Error("Canvas not supported"));
                return;
            }

            context.drawImage(image, 0, 0, width, height);

            const outputType = file.type === "image/png" ? "image/png" : "image/jpeg";
            resolve(canvas.toDataURL(outputType, quality));
        };

        image.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            reject(new Error("Failed to load image"));
        };

        image.src = objectUrl;
    });
};